import { c as _c } from "react/compiler-runtime";
import { cloneElement } from 'react';
import Image from 'next/image';
import { haversineMiles } from '@/shared/geo';
import { formatLocationName } from '@/shared/text';
import LocationPin from 'assets/icons/location_pin.svg';
import ClockMiles from 'assets/icons/clock.svg';
import MapPin from 'assets/icons/map-pin.svg';
import BaseCard, { Meta } from '../atoms/BaseCard';
function AttractionCard(t0) {
  const $ = _c(39);
  const {
    a,
    coordinates,
    typeBadge,
    detailsLabel,
    onClick,
    showActionArea: t1,
    metasDirection: t2,
    isActive: t3
  } = t0;
  const showActionArea = t1 === undefined ? true : t1;
  const metasDirection = t2 === undefined ? "responsive" : t2;
  const isActive = t3 === undefined ? false : t3;
  const slug = a.slug ?? a.id;
  const href = `/attraction/${encodeURIComponent(String(slug))}`;
  const hasHref = typeof href === "string" && href.length > 0;
  const altText = a?.title ? a.title : "";
  let leftContent;
  let t4;
  let t5;
  let t6;
  if ($[0] !== a.address || $[1] !== a.communityName || $[2] !== a.featured || $[3] !== a.locationCoordinates || $[4] !== a.locationName || $[5] !== a.thumbnail || $[6] !== altText || $[7] !== coordinates) {
    const dist = coordinates && haversineMiles(coordinates, a.locationCoordinates);
    const distanceMiles = dist && Number.isFinite(dist) ? Math.round(dist) : null;
    let t7;
    if ($[12] !== a.featured || $[13] !== a.thumbnail || $[14] !== altText) {
      t7 = <div className="lg:min-h-[104px] lg:h-full lg:w-[98px] w-[78px] h-[70px] overflow-hidden lg:rounded-[14px] rounded-lg bg-slate-200 relative mb-auto lg:mb-0">{a?.thumbnail ? <Image src={a.thumbnail} alt={altText} width={98} height={104} sizes="110px" className="h-full w-full object-cover absolute inset-0" priority={Boolean(a?.featured)} /> : <Image src="/images/attraction.jpg" alt={altText || ""} width={98} height={104} sizes="110px" className="h-full w-full object-cover absolute inset-0" />}</div>;
      $[12] = a.featured;
      $[13] = a.thumbnail;
      $[14] = altText;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    leftContent = t7;
    if ($[16] !== a.communityName) {
      t4 = a.communityName && <Meta iconSrc={MapPin} className="w-3.5 h-auto" alt="community" key="community">{a.communityName}</Meta>;
      $[16] = a.communityName;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    if ($[18] !== a.address || $[19] !== a.locationName) {
      t5 = (a.address || a.locationName) && <Meta iconSrc={LocationPin} alt="location pin" key="loc">{formatLocationName(a.address || a.locationName)}</Meta>;
      $[18] = a.address;
      $[19] = a.locationName;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    t6 = Number.isFinite(distanceMiles) && <Meta iconSrc={ClockMiles} width={13} height={10} className="w-3.5 h-auto" alt="directions" key="time">{distanceMiles} miles away</Meta>;
    $[0] = a.address;
    $[1] = a.communityName;
    $[2] = a.featured;
    $[3] = a.locationCoordinates;
    $[4] = a.locationName;
    $[5] = a.thumbnail;
    $[6] = altText;
    $[7] = coordinates;
    $[8] = leftContent;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    leftContent = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  let t7;
  if ($[21] !== typeBadge) {
    t7 = typeBadge && cloneElement(typeBadge, {
      key: "type"
    });
    $[21] = typeBadge;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7) {
    t8 = [t4, t5, t6, t7].filter(Boolean);
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  const metas = t8;
  let t9;
  if ($[28] !== a.title || $[29] !== detailsLabel || $[30] !== hasHref || $[31] !== href || $[32] !== isActive || $[33] !== leftContent || $[34] !== metas || $[35] !== metasDirection || $[36] !== onClick || $[37] !== showActionArea) {
    t9 = <BaseCard href={href} title={a.title} content={leftContent} metas={metas} featured={hasHref} detailsLabel={detailsLabel} onClick={onClick} showActionArea={showActionArea} metasDirection={metasDirection} isActive={isActive} />;
    $[28] = a.title;
    $[29] = detailsLabel;
    $[30] = hasHref;
    $[31] = href;
    $[32] = isActive;
    $[33] = leftContent;
    $[34] = metas;
    $[35] = metasDirection;
    $[36] = onClick;
    $[37] = showActionArea;
    $[38] = t9;
  } else {
    t9 = $[38];
  }
  return t9;
}
export default AttractionCard;